<form id="subjects-form-pg" [formGroup]="formGroup">
 <!-- Code Implementation for Contact Information class="flex flex-col gap-4" -->

 <p-panel styleClass="border-0 panel-dotted-heading">
    <div formArrayName="subjects">
        <div *ngFor="let subject of subjects.controls; let i = index" [formGroupName]="i" [ngClass]="{'mt-5': i > 0}">
            <div class="row mb-3">
                <div class="col-sm-12">
                    <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                    <h2 class="contactListNo">
                        <span *ngIf="i<9">Subject {{ '0'+ (i + 1) }}</span>
                        <span *ngIf="i>=9">Subject {{ i + 1 }}</span>
                    </h2>
                    <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true" aria-label="Delete"  label="Delete" *ngIf="subjects && subjects.length > 1" (onClick)="removeSubject(i)"></p-button>
                    </div>
                    <!--  <hr /> -->
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="subject-name-{{i}}" class="form-label d-block required-asterisk">Record Subject Name</label>
                    <input pInputText type="text" id="subject-name-{{i}}" class="w-100" placeholder="Enter record subject name"
                        formControlName="recordSubjectName" [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName',subject)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('recordSubjectName',subject)" class="error-label">This field is mandatory</small>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="subject-alias-{{i}}" class="form-label d-block">Alias</label>
                    <input pInputText type="text" id="subject-alias-{{i}}" class="w-100" placeholder="Enter alias"
                    formControlName="alias" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label class="form-label required-asterisk">Date of Birth</label>
                    <p-datepicker id="subject-dateofbirth" placeholder="mm/dd/yyyy" formControlName="dateOfBirth" [maxDate]="maxDate"
                        showIcon iconDisplay="input" styleClass="w-100" [ngClass]="{'ng-invalid ng-dirty' : isError('dateOfBirth',subject)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('dateOfBirth',subject)" class="error-label">This field is mandatory</small>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="subject-ssn-{{i}}" class="form-label d-block">Last 4 Digits of SSN </label>
                    <p-inputnumber type="text" id="subject-ssn-{{i}}" class="w-100" placeholder="Enter last 4 digits of SSN" [useGrouping]="false" [maxlength]="4"
                    formControlName="ssn" (onInput)="onSsnChange($event, i)"/>
                    <small id="subject-ssn-{{i}}" *ngIf="isError('ssn',subject)" class="error-label">This field must be exactly 4 digits</small>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="subject-dateofdeath-{{i}}" class="form-label d-block">Date of Death (if Applicable)</label>
                    <p-datepicker id="subject-dateofdeath" placeholder="mm/dd/yyyy" formControlName="dateOfDeath" [maxDate]="maxDate"
                        showIcon iconDisplay="input" styleClass="w-100" />
                </div>
            </div>                        
        </div>
    </div> 
</p-panel>
<p-button label="Add New Subject" styleClass="px-0" icon="pi pi-plus" (onClick)="addNewSubject()" [link]="true" />
</form>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'" (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
</app-modal>